export const contacts = state => {
  return state.contacts;
};
